import React from 'react';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

type Props = {
  onClick: () => void;
};

export default function PayWallCancelButton(props: Props): JSX.Element {
  const { onClick } = props;

  return <Button onClick={onClick}>Cancel</Button>;
}
